import { fromJS } from 'immutable';
import * as types from '../constants';
import { settingsDefault } from './db';
import { ThemeData } from './theme-data-reducer/themeData';

const defaultState = fromJS({
  status: false,
  title: 'Best-Selling Product',
  slides_preview: 4,
  listProductsIds: [],
  showHomePages: true,
  showProductPages: true,
  removeProductSold: false,
  showCartPages: true,
  showCollectionPages: true,
  showDesktop: true,
  showMobile: true,
  bgColor: '#FFFFFF',
  TitleColor: '#000000',
  bgImgColor: '#f17320',
  productTitleColor: '#000000',
  priceColor: '#D6946F',
  originalPriceColor: '#B1B1B1',

  settings: settingsDefault,
  layoutTheme: 'theme-1',
  productDetail: [],

  getSettingLoading: true,
  saveSettingLoading: false,
  saveSettingResult: 0,
  heightImage: '236',
  widthImage: '236'
});

let res = '';
let listProductsIds = [];
let listDetail = [];
let settings = {};

const bestSellingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_BEST_SELLING_FIELD:
      res = action.payload;
      return state.set(res.field, res.value);

    case types.CHANGE_BEST_SELLING_SETTINGS:
      res = action.payload;
      return state.setIn(['settings', res.field], res.value);

    case types.GET_SETTING_BEST_SELLING:
      return state.set('getSettingLoading', true);
    case types.GET_SETTING_BEST_SELLING_RESULT:
      res = action.res;
      if (res) {
        settings = res.settings ? JSON.parse(res.settings) : settingsDefault;
        if (!res.layout && res.bg_color) {
          settings.bgColor = res.bg_color;
          settings.TitleColor = res.title_color;
          settings.productTitleColor = res.product_title_color;
          settings.priceColor = res.price_color;
          settings.originalPriceColor = res.original_price_color;
        }
        if (!settings.heightDesktopImage) {
          settings.heightDesktopImage = '236';
        }
        if (!settings.widthDesktopImage) {
          settings.widthDesktopImage = '236';
        }
        if (!settings.heightMobileImage) {
          settings.heightMobileImage = '236';
        }
        if (!settings.widthMobileImage) {
          settings.widthMobileImage = '236';
        }
        return state
          .set('status', res.status)
          .set('title', res.title)
          .set('listProductsIds', fromJS(JSON.parse(res.list_products || '[]') || []))
          .set('showHomePages', res.show_home_pages)
          .set('showProductPages', res.show_product_pages)
          .set('showCartPages', res.show_cart_pages)
          .set('showCollectionPages', res.show_collection_pages)
          .set('showDesktop', res.show_desktop)
          .set('showMobile', res.show_mobile)
          .set('removeProductSold', res.remove_product_sold)
          .set('layoutTheme', res.layout || 'theme-1')
          .set('settings', fromJS(settings))
          .set('slides_preview', res.slides_preview)
          .set('getSettingLoading', false);
      }
      return state.set('getSettingLoading', false);
    case types.CHANGE_BEST_SELLING_THEME:
      return state
        .set('settings', fromJS(ThemeData[action.theme]))
        .set('layoutTheme', action.theme);
    case types.SAVE_SETTING_BEST_SELLING:
      return state.set('saveSettingLoading', true).set('saveSettingResult', 0);
    case types.SAVE_SETTING_BEST_SELLING_RESULT:
      return state.set('saveSettingLoading', false).set('saveSettingResult', action.res);

    case types.CLEAR_DATA_BEST_SELLING:
      return state.set('getSettingLoading', true).set('saveSettingResult', 0);

    case types.ADD_PRODUCT_BEST_SELLING:
      listProductsIds = state.get('listProductsIds').toJS();

      if (action.selection) {
        action.selection.forEach(item => {
          const id = parseInt(item.id.substr(item.id.lastIndexOf('/') + 1));

          if (listProductsIds.indexOf(id) === -1) listProductsIds.push(id);
        });
      }

      return state.set('listProductsIds', fromJS(listProductsIds));
    case types.REMOVE_PRODUCT_BEST_SELLING:
      listDetail =
        state.get('productDetail').filter(item => item.get('id') !== action.id) || fromJS([]);
      listProductsIds =
        state
          .get('listProductsIds')
          .filter(
            item => parseInt(item) !== parseInt(action.id?.replace('gid://shopify/Product/', ''))
          ) || fromJS([]);
      return state.set('listProductsIds', listProductsIds).set('productDetail', listDetail);

    case types.GET_LIST_PRODUCTS_DETAIL_BEST_SELLING:
      return state.set('getListProductsLoading', true);
    case types.GET_LIST_PRODUCTS_DETAIL_BEST_SELLING_RESULT:
      if (action.products) {
        return state
          .set('productDetail', fromJS(action.products))
          .set('getListProductsLoading', false);
      }
      return state.set('getListProductsLoading', false);
    default:
      return state;
  }
};

export default bestSellingReducer;
